// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__3S8M7","button":"Menu_button__3SiTj"};